import { useCallback } from "react";
import { NameEditor } from "../components/editor/NameEditor";
import { Btn } from "../components/UI/Btn";
import { useBackendContext } from "../services/backend/backendContextProvider";
import { useStrokeContext } from "../services/editor/editorContext";
import { useRouterContext } from "../services/router/routerContext";

import style from '../components/UI/Layout.module.css';

export const Color: React.FC = () => {

    const { comment, processedBase64, processedNormalized, color } = useStrokeContext();

    const { submit } = useBackendContext();

    const { showColor, showStage } = useRouterContext();

    const maySubmit = !!(processedBase64 && processedNormalized && color && (comment && comment.length > 2));




    const backHandler = useCallback(() => {

        showColor();

    }, [showColor]);

    const nextHandler = useCallback( async () => {

        if ( maySubmit && comment && color && processedBase64 && processedNormalized ) {

            submit(
                JSON.stringify( processedNormalized ),
                processedBase64,
                color,
                "blue",
                comment
            );

            showStage();

        }

    }, [submit, maySubmit, comment, processedBase64, processedNormalized, color, showStage]);

    return <>

        <Btn
            area="left"
            icon="left"
            square
            inverse
            onClick={backHandler}
        />

        {maySubmit && <Btn
            area="right"
            icon="submit"
            square
            onClick={nextHandler}
        />}

        <div className={style.centeredMax}>
            <div className={style.inner}>
                <NameEditor />
            </div>
        </div>


    </>



}